"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _classnames = _interopRequireDefault(require("classnames"));

var _chevronLeft = _interopRequireDefault(require("../../assets/icons/chevron-left.svg"));

var _chevronRight = _interopRequireDefault(require("../../assets/icons/chevron-right.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.simple-sidebar-container {\n  font-family: \"OpenSansRegular\";\n  border-right: 0.125rem solid #8d8d8d;\n  position: relative;\n  width: 0.5rem; }\n  .simple-sidebar-container .sidebar-toggle-arrow {\n    position: absolute;\n    right: -2rem;\n    top: 1rem;\n    cursor: pointer;\n    height: 1.5rem;\n    width: 1.5rem; }\n\n.simple-sidebar-container.active {\n  min-width: 20.5rem; }\n  .simple-sidebar-container.active .sidebar-toggle-arrow {\n    right: 0.5rem; }\n";
  var fileName = "compone_sidebar";
  var element = document.querySelector("style[data-sass-component='compone_sidebar']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var SimpleSidebar = function SimpleSidebar(_ref) {
  var _drawerClass;

  var isOpen = _ref.isOpen,
      onToggle = _ref.onToggle,
      children = _ref.children,
      width = _ref.width,
      height = _ref.height;
  var drawerClass = (_drawerClass = {}, _defineProperty(_drawerClass, _constants.classes.container, true), _defineProperty(_drawerClass, _constants.classes.containerActive, isOpen), _drawerClass);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, drawerClass)),
    style: _objectSpread({
      height: height
    }, isOpen ? {
      width: width
    } : {})
  }, /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "toggle",
    className: _constants.classes.arrow,
    src: isOpen ? _chevronLeft.default : _chevronRight.default,
    onClick: onToggle
  }), isOpen && children);
};

var _default = SimpleSidebar;
exports.default = _default;